import * as React from 'react'
import {Link} from "gatsby"

const Overlay = () => {
    return (
        <div>
            <div className="pop-up-media">
                <figure>
                    <img alt="" className="ort-img" src={"/images/Herrenchiemsee/teaser-herrenchiemsee.jpg"}/>
                    <figcaption>
                        Quelle: Bildarchiv Bayerischer Landtag, Foto: Rolf Poss
                    </figcaption>
                </figure>
            </div>
            <div className="pop-up-body">
                <p className='ort-header'>
                    1948: Herrenchiemsee </p>
                <p className="ort-subheader">
                    <i>„Das Werk… wird so vielen großen Aufgaben gerecht werden müssen.“</i>
                </p>
                <Link to="/orte/herrenchiemsee/" className='ort-text icon-arrow-right load-infobox'>
                    Mehr erfahren
                </Link>
            </div>

        </div>
    )
}

export default Overlay

